import { useMemo } from "react";

import FileUploadButton from "./FileUploadButton";
import DocumentUploaded from "./status/DocumentUploaded";
import DocumentViewed from "./status/DocumentViewed";
import DocumentVerified from "./status/DocumentVerified";
import { docsFunctions } from "../../../../../lib/docs";
import { practicesFunctions } from "../../../../../lib/practices";

import classes from './status/Status.module.css'

const FLAG_SATISFIED_USE_FOR = ['HIPAA', 'LOP']

export default function PracticesUploadItem({practiceId, usedFor, documentTypeOverride, missingDocumentTypeUploadErrorMessage, uploadDisabled, caseAttorneyId, right, activeCase, uploadPermission, updatePermission, btnRed}) {
    const docTypeId = documentTypeOverride?.id ?? docsFunctions.returnDocumentTypeID(usedFor)?.id

    const practiceRow = activeCase?.practices?.find(item => item.practice_id == practiceId)
    const satisfiedByFlag = FLAG_SATISFIED_USE_FOR.includes(usedFor) && practicesFunctions.isProcodocSatisfiedForPractice(
        usedFor,
        practiceId,
        practiceRow,
        null,
        activeCase,
        caseAttorneyId
    )

    const flagSatisfiedTitle = usedFor === 'HIPAA' ? 'HIPAA on file' : usedFor === 'LOP' ? 'LOP on file' : null

    const displayDocument = useMemo(() => (
        docsFunctions.getUploadedDocumentState(activeCase?.procodocs_documents, docTypeId, practiceId, caseAttorneyId)
    ), [activeCase, caseAttorneyId, practiceId, docTypeId])

    const isGeneral = displayDocument ? docsFunctions.isDocumentGeneral(displayDocument, practiceId) : false
    const isInheritedGeneral = Boolean(displayDocument && isGeneral && practiceId !== 'all')
    const coveredByGeneralOnly = practiceId !== 'all' && (isInheritedGeneral || (!displayDocument && satisfiedByFlag))
    const uploadBtnRed = btnRed && !coveredByGeneralOnly

    const renderUploadButton = (compact = false) => !uploadDisabled && uploadPermission ? (
        <FileUploadButton
            practiceId={practiceId}
            documentTypeId={docTypeId}
            caseAttorneyId={caseAttorneyId}
            usedFor={usedFor}
            activeCase={activeCase}
            btnRed={uploadBtnRed}
            compact={compact}
            missingDocumentTypeUploadErrorMessage={missingDocumentTypeUploadErrorMessage}
        />
    ) : null

    const statusProps = displayDocument ? {
        practiceId,
        usedFor,
        documentItem: displayDocument,
        uploadDisabled,
        isGeneral,
        right,
        activeCase,
        uploadPermission,
        updatePermission,
    } : null

    const renderDocumentStatus = () => {
        if (!statusProps) {
            return null
        }

        if (displayDocument.is_viewed) {
            if (displayDocument.is_verified) {
                return <DocumentVerified {...statusProps} />
            }
            return <DocumentViewed {...statusProps} />
        }

        return <DocumentUploaded {...statusProps} />
    }

    return <>
        {!displayDocument && satisfiedByFlag && (
            <div className={classes.document_item_row}>
                <div className={classes.flag_satisfied_icon}>
                    <i className="ti ti-check" title={flagSatisfiedTitle}></i>
                </div>
                {renderUploadButton(true)}
            </div>
        )}
        {!displayDocument && !satisfiedByFlag && renderUploadButton(false)}
        {displayDocument && (
            isInheritedGeneral ? (
                <div className={classes.document_item_row}>
                    {renderDocumentStatus()}
                    {renderUploadButton(true)}
                </div>
            ) : (
                renderDocumentStatus()
            )
        )}
    </>
}
